import { LoansScreen } from "./LoansScreen";

export const PhysicalLoansScreen = () => {
  return <LoansScreen component="Physical" />;
};
